"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReferralTokenFromPage = void 0;
var csod = require("player-core");
var Constants_1 = require("./Constants");
var CookieHelper_1 = require("./CookieHelper");
exports.getReferralTokenFromPage = function () {
    var qsParams = csod.utils.parseQuery();
    return qsParams.referralToken
        || window.localStorage.getItem(Constants_1.REC_REFERRAL_TOKEN)
        || CookieHelper_1.CookieHelper.get(Constants_1.REC_REFERRAL_TOKEN);
};



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/shared/code/ReferralTokenHelper.ts
// module id = 192
// module chunks = 0 2